var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',{attrs:{"value":_vm.getCurrentTagList,"options":_vm.options,"multiple":true,"label":"name"},on:{"input":_vm.updateTagStates,"select":_vm.addTagToStore,"remove":_vm.updateTags}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }